import { userHasRight } from "../../../framework";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_LabelLink from "../templates/K_LabelLink";
import { ComponentOptions, RightLockable } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface LabelLinkOptions extends ComponentOptions {
    title?: string;
    label?: string;
    bindLabel?: string;
    valueClasses?: string;
    bsc?: string;
    tooltip?: string;
    requiredRight?: string;
}

export class LabelLink extends TemplateComponent {

    options: LabelLinkOptions & RightLockable;

    constructor(options: LabelLinkOptions) {
        super(K_LabelLink, options);
    }

    preRender() {
        const options = this.options;

        options.title = options.label || null;
        options.containerClasses = options.containerClasses || "";
        options.bindValue = buildDataBindSyntax(options.bindValue, "customText");
        options.bindLabel = buildDataBindSyntax(options.bindLabel, "label");

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.containerClasses += " right-locked";
            }
        }
    }

}
